"use client";

import Script from "next/script";
import { useEffect, useState } from "react";
import { useUser } from "@/providers/user-provider";

const TAWK_EMBED_SRC = "https://embed.tawk.to/6982226da22a7a1c386ed6f5/1jgi5cv3s";

/**
 * Defer real do chat: o `strategy="lazyOnload"` do next/script dispara no
 * evento `load` da página — que num app SPA já passou há muito quando o role
 * chega, então na prática o Tawk injetava IMEDIATAMENTE e disputava rede/CPU
 * com o first paint do dashboard (~20 requests medidos no profile).
 */
export const TAWK_DEFER_MS = 4_000;

export function TawkWidget() {
  const { user } = useUser();
  const role = user?.client?.role;
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (role !== "CLIENT") return;
    const t = setTimeout(() => setReady(true), TAWK_DEFER_MS);
    return () => clearTimeout(t);
  }, [role]);

  // Only show widget for CLIENT users — e só depois do defer.
  if (role !== "CLIENT" || !ready) {
    return null;
  }

  return (
    <Script id="tawk-to" strategy="lazyOnload">
      {`
var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
(function(){
var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
s1.async=true;
s1.src='${TAWK_EMBED_SRC}';
s1.charset='UTF-8';
s1.setAttribute('crossorigin','*');
s0.parentNode.insertBefore(s1,s0);
})();
      `}
    </Script>
  );
}
